import { useCallback } from 'react';
import UserApi from 'libs/api/user';
import { usePaginatedList } from 'hooks/use-paginated-list';

const usersApi = new UserApi();

const fetchAvailableCompanies = ({ page, per }) =>
  usersApi.getAvailableCompanies({ page, per });

const getCompaniesFromResponse = (data) => data.companies;

export const useAvailableCompanies = ({ enabled = true } = {}) => {
  const {
    items: companies,
    loadMore,
    hasNextPage,
    isLoading,
    isLoadingMore,
    pagination,
    reset,
  } = usePaginatedList({
    fetchPage: fetchAvailableCompanies,
    getItems: getCompaniesFromResponse,
    enabled,
  });

  return {
    companies,
    loadMore,
    hasNextPage,
    isLoading,
    isLoadingMore,
    pagination,
    reset,
  };
};
